define(function(require){
    'use strict';
    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: {
            from: '',
            subject: '',
            text: ''
        },

        validate: function(attrs, options) {
            var errors = [];
            if (!attrs.subject) {
                errors.push({
                    field: 'subject',
                    message: 'Введите тему сообщения!'
                })
            }
            if (!attrs.text) {
                errors.push({
                    field: 'text',
                    message: 'Введите текст сообщения!'
                })
            }
            return errors.length && errors;
        }
    });

});